var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _circle2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle3, _path15, _circle4, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconOther = function SvgIconOther(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41,
    clipRule: "evenodd",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0cef2",
    d: "M33.83 5.27c1.42.42 2.92.5 4.38.24 2.23-.4 4.47-.74 6.7-1.14 0 0 .04-.01.14 0 .28.03.46.27.45.54-.4 2.6-1 5.15-1.54 7.71a3.63 3.63 0 0 1-2.96 2.7v.62a5.54 5.54 0 0 0 3 4.92 6.61 6.61 0 0 1-5.03 4.86c-4.14.9-9.97 2.14-9.97 2.14l-9.97-2.14A6.61 6.61 0 0 1 14 20.86c1.84-.95 3-2.85 3-4.92v-1.08a10 10 0 0 1 2.42-6.53L13 4.78l5.03.87c2.05.36 4.15.23 6.14-.36.91-.29 1.86-.43 2.83-.43h4a10 10 0 0 1 2.83.41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b96962",
    d: "M19 24.86H3l-3-4h16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd1da",
    d: "m14 2.86-11-2 1.52 7.59a3 3 0 0 0 2.94 2.41H14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a4ba",
    fillRule: "nonzero",
    d: "M3.04.36c3.71.5 7.37 1.34 11.05 2 0 0 .36.13.4.45.13 2.68.01 5.37.01 8.05a.52.52 0 0 1-.45.5c-2.22.1-4.45.02-6.67 0a3.62 3.62 0 0 1-3.34-2.74C3.5 6.07 3.02 3.52 2.51.96c-.05-.32.09-.62.53-.6m1.97 7.99c.24 1.13 1.29 2 2.45 2.01h6.04V3.28l-9.87-1.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4.86,
    r: 3,
    fill: "#e86fa0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd1da",
    d: "m24 2.86 11-2-1.52 7.59a3 3 0 0 1-2.94 2.41H24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a4ba",
    fillRule: "nonzero",
    d: "M35.05.36c.27.04.46.27.45.55-.4 2.6-1 5.15-1.54 7.71a3.61 3.61 0 0 1-3.34 2.74c-2.2.02-4.41 0-6.62 0a.52.52 0 0 1-.5-.45c-.12-2.68 0-5.37 0-8.05a.52.52 0 0 1 .36-.48c3.65-.84 7.37-1.34 11.05-2.01 0 0 .04-.01.14 0zM24.5 3.28v7.08c2.03 0 4.06.02 6.1 0A2.59 2.59 0 0 0 33 8.35l1.37-6.87z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4.86,
    r: 3,
    fill: "#e86fa0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a4ba",
    d: "M4 16.86c1.84-.95 3-2.85 3-4.92v-1.08a10 10 0 0 1 2.42-6.53L3 1.78v-1l5.03.87c2.05.36 4.15.23 6.15-.36.9-.29 1.85-.43 2.82-.43h4a10 10 0 0 1 2.83.41c2 .6 4.1.71 6.14.36L35 .78v1l-6.42 2.55A10 10 0 0 1 31 10.86v1.08a5.54 5.54 0 0 0 3 4.92 6.61 6.61 0 0 1-5.03 4.86c-4.14.9-9.97 2.14-9.97 2.14l-9.97-2.14A6.61 6.61 0 0 1 4 16.86"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c7f",
    d: "M6.17 14.86c2.22 2.54 5.43 4 8.81 4h8.04c3.38 0 6.59-1.46 8.81-4a5.54 5.54 0 0 0 2.17 2 6.61 6.61 0 0 1-5.03 4.86L25 22.86H10.67l-1.64-1.14A6.61 6.61 0 0 1 4 16.86a5.53 5.53 0 0 0 2.17-2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c7f",
    d: "M11 18.36h15v12.5H11z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2e9",
    d: "M28 17.36a4.5 4.5 0 0 0-4.5-4.5h-9a4.5 4.5 0 1 0 0 9h9a4.5 4.5 0 0 0 4.5-4.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.76 14.86h.5A1.75 1.75 0 0 1 13 16.61c0 .97-.78 1.75-1.75 1.75h-1.14a4.48 4.48 0 0 1 .65-3.5m16.48 0h-.5A1.75 1.75 0 0 0 25 16.61c0 .97.78 1.75 1.75 1.75h1.14a4.48 4.48 0 0 0-.65-3.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#afafc2",
    d: "M23 17.86h-8v1a4 4 0 0 0 8 0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 20.86a1 1 0 0 0-1-1h-.03a.97.97 0 0 0-.97.98v.05a.97.97 0 0 0 .97.97H19a1 1 0 0 0 1-1m3-2.99a2.01 2.01 0 0 0-2.01-2h-3.98a2 2 0 0 0-2.01 2 1.23 1.23 0 0 0 1.78 1.1l2.22-1.1 2.22 1.1a1.23 1.23 0 0 0 1.78-1.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2e9",
    d: "M16.23 7.04c.44-.1.74-.5.74-.94.03-.08.03-.16.03-.24a2 2 0 1 1 4 0v.24a1 1 0 0 0 .76.97 4.44 4.44 0 0 1 3.24 4.3 4.5 4.5 0 0 1-4.5 4.5h-3a4.5 4.5 0 1 1-1.27-8.82z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b233f",
    d: "M17 13.86a3 3 0 0 0-3-3h-1a1 1 0 0 0-1 1 3 3 0 0 0 3 3h1a1 1 0 0 0 1-1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 11.86,
    r: 1,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b233f",
    d: "M21 13.86a3 3 0 0 1 3-3h1a1 1 0 0 1 1 1 3 3 0 0 1-3 3h-1a1 1 0 0 1-1-1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 11.86,
    r: 1,
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c7f",
    d: "M17 7.86a1 1 0 0 0-1-1h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1m7 0a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2h1a1 1 0 0 0 1-1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc6da",
    d: "m18.58 16.79-.9-.9a.6.6 0 0 1 .42-1.03h1.8a.6.6 0 0 1 .42 1.03l-.9.9a.6.6 0 0 1-.84 0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#696788",
    d: "M24.14 1.28a1.14 1.14 0 0 0-2.29 0v1.15c0 .63.52 1.14 1.15 1.14s1.14-.5 1.14-1.14zm-8 .01a1.14 1.14 0 0 0-2.29 0v1.15c0 .63.52 1.14 1.15 1.14s1.14-.51 1.14-1.14zm4 0a1.14 1.14 0 0 0-2.29 0c0 .64.52 1.15 1.15 1.15s1.14-.51 1.14-1.14z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#eec8ad",
    d: "M19 24.86h26.04v23H19z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3998d",
    d: "M39 43.86h2.04v4H39z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e5d8",
    d: "M3 24.86h26.04v23H3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d7c3",
    d: "M3 24.86h2v23H3zm4 0h2v23H7zm4 0h2v23h-2zm4 0h2v23h-2zm4 0h2v23h-2zm4 0h2v23h-2zm4 0h2v23h-2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7aba2",
    d: "M29 24.86h2v23h-2zm4 0h2v23h-2zm4 0h2v23h-2zm4 0h2v23h-2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3998d",
    d: "M38.96 24.9H41v4h-2.04z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#d08b87",
    d: "M41 24.9h2v4h-2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3998d",
    d: "M42.96 24.9H45v4h-2.04z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#b86a6c",
    d: "M36 24.86h4v23h-4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#d18883",
    d: "M48 20.86H32l-3 4h16z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e5d8",
    d: "M35 24.86h4v23h-4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 30.36h4v12h-4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e5d8",
    d: "M39 24.86h-4v6a2 2 0 0 0 4 0zm-4 23h4v-6a2 2 0 1 0-4 0z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#b96962",
    d: "m31.7 21.25.1.23a2.5 2.5 0 0 0 2.24 1.38H46.5l-1.5 2H29l2.7-3.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc7b5",
    d: "M3 43.86h2v4H3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d7c3",
    d: "M5 43.86h2v4H5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc7b5",
    d: "M7 43.86h2v4H7z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d7c3",
    d: "M9 43.86h2v4H9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc7b5",
    d: "M11 43.86h2v4h-2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d7c3",
    d: "M13 43.86h2v4h-2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc7b5",
    d: "M15.02 43.86h2v4h-2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d7c3",
    d: "M17.02 43.86h2v4h-2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc7b5",
    d: "M19.02 43.86h2v4h-2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d7c3",
    d: "M21.02 43.86h2v4h-2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc7b5",
    d: "M23.02 43.86h2v4h-2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d7c3",
    d: "M25.02 43.86h2v4h-2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc7b5",
    d: "M27.02 43.86h2v4h-2z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#d08b87",
    d: "M29 43.86h2v4h-2zm4 0h2v4h-2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3998d",
    d: "M31 43.86h2v4h-2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#d08b87",
    d: "M41.04 43.86h2v4h-2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3998d",
    d: "M43 43.86h2.04v4H43z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#b86a6c",
    fillOpacity: 0.5,
    d: "M33 28.46V24.9h2v3.96l-1.6-.23zm-3.98-3.56h1.94v2.38a6 6 0 0 1-1.87-2.24z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#b86a6c",
    fillOpacity: 0.5,
    d: "M30.96 27.28V24.9H33v3.56l-1.35-.6-.7-.58z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#d18883",
    d: "M23 30.36a1.5 1.5 0 0 0-1.5-1.5h-7a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 1.5-1.5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5c7f",
    d: "M23 30.36a1.5 1.5 0 0 0-1.5-1.5h-5a1.5 1.5 0 0 0 0 3h5a1.5 1.5 0 0 0 1.5-1.5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#faf3ed",
    d: "M22 32.86a1 1 0 0 0-1-1h-6a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 32.86a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a4ba",
    d: "M24 21.86h2a3 3 0 0 1 3 3h-1.23a.93.93 0 0 0-.91.75A2.91 2.91 0 0 1 24 27.86a3 3 0 0 1 0-6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2e9",
    d: "M25.5 23.84a.98.98 0 0 0-.97-.98h-1a1.03 1.03 0 0 0-1.03 1.03.97.97 0 0 0 .97.97h1a1.02 1.02 0 0 0 1.03-1.02"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a4ba",
    d: "M8 21.86h2a3 3 0 0 1 3 3h-1.23a.93.93 0 0 0-.91.75A2.91 2.91 0 0 1 8 27.86a3 3 0 0 1 0-6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2e9",
    d: "M9.5 23.84a.98.98 0 0 0-.97-.98h-1A1.03 1.03 0 0 0 6.5 23.9a.97.97 0 0 0 .97.97h1a1.02 1.02 0 0 0 1.03-1.02z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8a8a2",
    d: "M35 43.86h4v4h-4zm0-18.96h4v4h-4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconOther);
export default ForwardRef;